import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ZohoService } from '../services/zoho.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {
  public zohoCRMForm: FormGroup | any;
  public submitted: boolean = false;
  public accessToken: any;
  public processing: boolean = false;

  constructor(
    private fb: FormBuilder,
    private zohoService: ZohoService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.zohoCRMForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      message: ['', Validators.required],
    });

  }

  /**
 * getter function
 */
  get f() {
    return this.zohoCRMForm.controls;
  }

  /**
   * Determines whether submit on
   */
  public onSubmit() {
    this.submitted = true;
    this.processing = true;
    if (this.zohoCRMForm.valid) {
      this.zohoService.sendEmail(this.zohoCRMForm.value).subscribe({
        next: (response: any) => {
          this.processing = false;
          console.log('response', response);
          this.toastr.success('Newsletter sent successfully');
        },
        error: (error: any) => {
          this.processing = false;
          this.toastr.error(error.message);
        },
      });
    }
  }

}
